<template>
  <Collapse
    class="green-operation__assessment green-operation__green-building-certificate"
  >
    <template #title>
      <HKLLeftRight>
        <span class="font-bold">{{ $t('tenancy.greenOperation.assessments.greenBuildingCertificate.title') }}</span>
        <HKLInputPoints
          v-if="!isEdit && canViewPoint"
          v-model="points"
          :isEdit="false"
        />
      </HKLLeftRight>
    </template>
    <template #content>
      <div>
        <HKLLeftRight class="green-operation__assessment-title">
          <span class="font-bold">
            {{ $t('tenancy.greenOperation.assessments.greenBuildingCertificate.greenBuilding') }}
          </span>
          <HKLInputPoints
            v-if="canViewPoint"
            v-model="greenBuildingCertificate.point"
            :isEdit="isEdit"
          />
        </HKLLeftRight>
        <template v-if="isTenant && greenBuildingCertificate.value.length === 0">
          {{ $t('emptyValue') }}
        </template>
        <GreenBuildingCertificateTable
          v-else-if="greenBuildingCertificate.value.length > 0 || isEdit"
          :dataSource="greenBuildingCertificate.value"
        />
      </div>
      <HKLTable
        class="cert__doc-table"
        v-if="tableAttrs.dataSource.length > 0"
        v-bind="tableAttrs"
      />
    </template>
  </Collapse>
</template>

<script>
import Collapse from '@/controls/Collapse.vue'
import HKLLeftRight from '@/controls/Layout/HKLLeftRight.vue'
import HKLTable from '@/controls/Table/HKLTable.vue'
import { useStoreGetters } from '@/store/index'
import { whenever } from '@vueuse/core'
import lodash from 'lodash'
import { computed, reactive, toRefs } from 'vue-demi'
import { useGreenOperationPerms } from '../GreenOperationLetter.hook'
import GreenBuildingCertificateTable from '../components/GreenBuildingCertificateTable.vue'
import HKLInputPoints from '../components/HKLInputPoints.vue'
import { GREEN_OPERATION_ASSESSMENT_TYPE } from '../consts'
import { useGreenOperation, useGreenOperationAssessmentFormStatus, useGreenOperationField } from '../hook'
import { useAssessmentDocumentTableAttrs, useAssessmentForm, useSelectedLetterId } from './hook'
import { totalPoints } from './utils'

const ASSESSMENT_TYPE = GREEN_OPERATION_ASSESSMENT_TYPE.GREEN_CERT

export default {
  components: {
    Collapse,
    HKLTable,
    HKLLeftRight,
    HKLInputPoints,
    GreenBuildingCertificateTable,
  },
  setup () {
    const sourceId = useGreenOperationField('id', '')
    const { isSuccess } = useGreenOperation()
    const { isSelectedLetterSuccess } = useSelectedLetterId()
    const { isEdit } = useGreenOperationAssessmentFormStatus()
    const { isTenant } = useStoreGetters('user', ['isTenant'])
    const { canViewPoint } = useGreenOperationPerms()
    const tableAttrs = useAssessmentDocumentTableAttrs(sourceId, GREEN_OPERATION_ASSESSMENT_TYPE.GREEN_CERT)
    const formMap = reactive({
      greenBuildingCertificate: useAssessmentForm(
        ASSESSMENT_TYPE,
        'greenBuildingCertificate',
        [],
      ),
    })
    whenever([isSuccess, isSelectedLetterSuccess], () => {
      formMap.greenBuildingCertificate.value = lodash.orderBy(
        formMap.greenBuildingCertificate.value,
        [(cert) => cert.period[1], 'issuer'],
        ['asc', 'asc'],
      )
    })
    return {
      isEdit,
      isTenant,
      canViewPoint,
      tableAttrs,
      ...toRefs(formMap),
      points: computed(() => totalPoints(formMap)),
    }
  },
}
</script>

<style lang="scss" scoped>
@import './common.scss';
.green-operation__green-building-certificate {
  ::v-deep {
    .cert__doc-table.hkl-table {
      overflow: unset;
    }
    .content {
      overflow: auto;
    }
  }
}
</style>
